import { supabaseWorker } from '@/integrations/supabase/workerClient';

export type StatusOrderTable =
  | 'order_statuses'
  | 'rental_statuses'
  | 'payment_statuses'
  | 'inventory_statuses'
  | 'workshop_statuses';

type OrderRow = { sort_order?: number } | null;

async function fetchCurrentMaxOrder(
  table: StatusOrderTable,
  userId: string,
): Promise<number | undefined> {
  const { data, error } = await supabaseWorker
    .from(table)
    .select('sort_order')
    .eq('user_id', userId)
    .order('sort_order', { ascending: false })
    .limit(1)
    .maybeSingle();

  const errorCode = (error as { code?: string } | null)?.code;
  if (error && errorCode !== 'PGRST116') {
    throw error;
  }

  return (data as OrderRow)?.sort_order;
}

export async function getNextStatusOrderValue(
  table: StatusOrderTable,
  userId: string,
): Promise<number> {
  const currentOrder = await fetchCurrentMaxOrder(table, userId);
  return typeof currentOrder === 'number' ? currentOrder + 1 : 0;
}

export async function getStatusOrderSequence(
  table: StatusOrderTable,
  userId: string,
  count: number,
): Promise<number[]> {
  const currentOrder = await fetchCurrentMaxOrder(table, userId);
  const start = typeof currentOrder === 'number' ? currentOrder + 1 : 0;
  return Array.from({ length: count }, (_, index) => start + index);
}
